export default "__VITE_ASSET__DZLPGGDs__"